module.exports = __webpack_public_path__ + "static/media/3box.c45fe013.png";